import { Router } from "@angular/router";
import { Component, OnInit, } from "@angular/core";
import { LoginService } from "../service/login/login.service";

import * as $ from 'jquery'
import { User } from "../models/users/user";

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.css']
})
export class HomeLayoutComponent implements OnInit {

  public loginY = "[]";
  public loginF;

  constructor(
    private loginService: LoginService,
    private router: Router,
  ) {
  }

  //当前用户
  _current_user: User = null;
  get currentUser() {
    return (
      this._current_user ||
      (JSON.parse(sessionStorage.getItem("currentUser")) || {}).user
    );
  }

  set currentUser(value) {
    this._current_user = value;
  }


  _logOut() {
    this.loginService.logout();
    this.router.navigate(["user/login"]);
  }

  // 初始化获取当前登录用户
  ngOnInit() {
    // this.router.navigate(["home/mainPage"])
    document.getElementById("tab" + 1).style.background = "#2b7dd7";

    if (sessionStorage.getItem("currentUser") != null) {
      this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      console.log(this.currentUser);
      this.loginY = undefined;
      this.loginF = "[]";


    } else {
      this.loginY = "[]";
      this.loginF = undefined;
    }

  }


  login() {
    this.router.navigate(["login"])
  }


  tab(num) {

    var url;
    if (num == 1) {

    } else if (num == 2) {
      url = "/situation"
    } else if (num == 3) {
      url = "/dataIntroduce"
    } else if (num == 4) {
      url = "/centerNews"
    } else if (num == 5) {
      url = "/dataQuery"
    } else if (num == 6) {
      url = "/productDisplay"
    } else if (num == 7) {
      url = "/contact"
    } else if (num == 8) {
      url = "/industryApplication"
    }else if (num == 9) {
      url = "/policyregulations"
    }else if (num == 10) {
      window.open("http://www.westgfdc.ac.cn/data-center/")
    }


    if (url != undefined) {
      this.router.navigate([url], {
        queryParams: {
          compareData: "tab" + num
        }
      })
    }


  }


  Ta(num) {

    var url;
    if (num == 1) {
      // url = "home/centerHome/centerTeam"
    } else if (num == 2) {
      url = "/centerBuild"
    } else if (num == 3) {

    } else if (num == 4) {
      url = "/centerOrangized"
    } else if (num == 5) {
      url = "/centerConduct"
    } else if (num == 6) {
      url = "/centerLeaders"
    }


    if (url != undefined) {
      this.router.navigate([url], {
        queryParams: {
          compareData: "tab" + 2
        }
      })
    }

  }



  intro(num) {
    for (var i = 1; i < 8; i++) {
      if (i == 3) {
        document.getElementById("tab" + i).style.background = "#2b7dd7";

      } else {
        document.getElementById("tab" + i).style.background = "";
      }
    }

    if (num == 1) {
      this.router.navigate(["/dataIntroduce"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    } else if (num == 2) {
      this.router.navigate(["/nature"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    } else if (num == 3) {
      this.router.navigate(["/production"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }
    else if (num == 4) {
      console.log("wozhixingle");
      this.router.navigate(["/ecotope"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }
    else if (num == 5) {
      console.log("wozhixingle");
      this.router.navigate(["/agriculture"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }
    else if (num == 6) {
      console.log("wozhixingle");
      this.router.navigate(["/antiTerrorist"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }
    else if (num == 7) {
      console.log("wozhixingle");
      this.router.navigate(["/calamities"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }
    else if (num == 8) {
      console.log("wozhixingle");
      this.router.navigate(["/culturalRelic"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }
    else if (num == 9) {
      console.log("wozhixingle");
      this.router.navigate(["/beautifulCountry"], {
        queryParams: {
          compareData: "tab" + 3
        }
      });
    }


  }


  info(num) {
    var url;
    if (num == 1) {
      url = "/centerNews"
    } else if (num == 2) {
      url = "/industryNews"
    } else if (num == 3) {
      url = "/noticeAnnouncement"
    }

    this.router.navigate([url], {
      queryParams: {
        compareData: "tab" + 4
      }
    })

  }


  data(num) {
    var url;
    if (num == 1) {
      url = "/dataQuery"
    } else if (num == 2) {
      url = "/cart"
    } else if (num == 3) {
      url = "/download"
    }

    this.router.navigate([url], {
      queryParams: {
        compareData: "tab" + 5
      }
    })
  }


  touch(num) {
    var url;
    if (num == 1) {
      url = "/contact"
    } else if (num == 2) {
      url = "/job"
    }

    this.router.navigate([url], {
      queryParams: {
        compareData: "tab" + 7
      }
    })

  }
  product(num) {

    if (num == 1) {
      this.router.navigate(["/productDisplay"], {
        queryParams: {
          compareData: "tab" + 6
        }
      });
    } else if (num == 2) {
      this.router.navigate(["/gfSatellite"], {
        queryParams: {
          compareData: "tab" + 6
        }
      });
    }
    else if (num == 3) {
      this.router.navigate(["/dataReceive"], {
        queryParams: {
          compareData: "tab" + 6
        }
      });
    } else if (num == 4) {
      this.router.navigate(["/dataDispose"], {
        queryParams: {
          compareData: "tab" + 6
        }
      });
    }
  }


}

